import { axios, addHeader } from '@/api/index.js'
const config = {
  getRoles: accessToken => {
    return axios.get('/config/getRoles', addHeader(accessToken))
  },
  getCustomerGroups: accessToken => {
    return axios.get('/config/getCustomerGroups', addHeader(accessToken))
  },
  getBilingGroupsbyCustomerGroup: accessToken => {
    //todo -remove hardcoding after the demo
    return axios.get('/config/getBilingGroupsbyCustomerGroup?customerGroup=1234', addHeader(accessToken))
  },
}

export default config
